function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawTravelers = function UndrawTravelers(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 532.15 688.51",
    style: style
  }, props), React.createElement("ellipse", {
    cx: 209.56,
    cy: 38.37,
    rx: 39.68,
    ry: 30.95,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 288.92,
    cy: 143.12,
    r: 57.14,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 470.25,
    cy: 649.84,
    r: 14.28,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 395.66,
    cy: 649.84,
    r: 14.28,
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M411.53 305.42h6.35v175.39h-6.35zM445.65 305.42H452v175.39h-6.35z"
  }), React.createElement("path", {
    d: "M413.08 310.18l-1.59-4.76s17.46-20.63 42.06-4l-1.59 7.15h-6.35s-10.31-8.65-27.77 1.23z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: "#fbbebe",
    d: "M249.24 280.42h57.14v73.01h-57.14zM328.6 259.78h17.46v34.92H328.6z"
  }), React.createElement("path", {
    d: "M256.78 635.56l-7.14 21.43s-3.18 15.87 7.14 16.66 27-2.38 27-2.38 2.38-7.14 0-13.49-9.52-23.81-9.52-23.81zM310.74 636.35s-11.11 27.78-2.38 32.54 20.64.79 30.16 4.76 35.71-5.55 35.71-5.55 3.18-8.73-14.28-11.11c0 0-19-14.29-19-17.46s-11.11-3.18-11.11-3.18z",
    fill: "#3c354c"
  }), React.createElement("path", {
    d: "M308.36 319.71s-65.07 13.49-73 9.52-15.87 54-15.87 54-3.18 34.92 7.93 81.74 0 69.84 0 69.84 1.59 44.44 13.5 65.08 11.9 39.68 11.9 39.68 23 2.38 23.81-3.18c0 0-9.53-22.22-7.94-42.85s-4.76-60.32-4.76-60.32 10.32-50 8.73-69 5.56-59.52 9.52-52.38 14.29 42.06 14.29 49.21 4 54.75 6.35 57.93 1.58 12.7.79 17.46-.79 40.47 3.17 59.52.8 40.47 1.59 43.65 23.81.79 24.6-4.77c0 0 3.18-34.12 4.77-38.88s2.34-65.16 2.34-65.16 1.58-46.82 3.17-51.58 4-107.14-6.35-119-6.35-42.06-6.35-42.06z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M254.87 181.46c-2.94 5.54-5.9 11.13-7.74 17.14s-2.48 12.52-.75 18.56a46 46 0 0 0 5.12 10.7 36.7 36.7 0 0 0 6.47 8.64c6 5.48 14.72 6.58 22.82 7.44a11.56 11.56 0 0 0 4.19-.07 7.92 7.92 0 0 0 3-1.64c3.55-3 5.16-7.58 6.46-12a198 198 0 0 0 6.62-32.14 14.89 14.89 0 0 0 0-5.2c-.7-3-3.1-5.33-4.84-7.91a20.17 20.17 0 0 1-3.44-10.4c-.07-1.81 0-3.81-1.14-5.19a7 7 0 0 0-2.69-1.66c-4.73-2-9.45-4-14.19-5.92-2.86-1.18-8-4.32-11-2-2.57 2-1.33 6.64-2.43 9.42-1.69 4.22-4.34 8.23-6.46 12.23z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M254.87 181.46c-2.94 5.54-5.9 11.13-7.74 17.14s-2.48 12.52-.75 18.56a46 46 0 0 0 5.12 10.7 36.7 36.7 0 0 0 6.47 8.64c6 5.48 14.72 6.58 22.82 7.44a11.56 11.56 0 0 0 4.19-.07 7.92 7.92 0 0 0 3-1.64c3.55-3 5.16-7.58 6.46-12a198 198 0 0 0 6.62-32.14 14.89 14.89 0 0 0 0-5.2c-.7-3-3.1-5.33-4.84-7.91a20.17 20.17 0 0 1-3.44-10.4c-.07-1.81 0-3.81-1.14-5.19a7 7 0 0 0-2.69-1.66c-4.73-2-9.45-4-14.19-5.92-2.86-1.18-8-4.32-11-2-2.57 2-1.33 6.64-2.43 9.42-1.69 4.22-4.34 8.23-6.46 12.23z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 286.14,
    cy: 155.43,
    r: 27.78,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M295.89 225.49c-5.26 1.89-10.69 3.52-16.28 3.72a53.89 53.89 0 0 1-12.45-1.33 158.09 158.09 0 0 1-24.78-7.07c-1.72 3.39-2.18 7.26-2.33 11.06-.43 11.49 1.86 22.89 2.74 34.36 1.11 14.58 0 29.48 3.75 43.6a12 12 0 0 1 2.68-6.54 14.84 14.84 0 0 1 4.49-3.3 35.8 35.8 0 0 1 24.58-3.06c4.81 1.14 9.92 3.27 14.48 1.36 2.72-1.15 4.69-3.57 6.2-6.11a50.22 50.22 0 0 0 5.42-14.69c3-13.24 3.4-26.93 3.76-40.51.1-3.63 1.66-14.42-1.35-17.08-2.11-1.85-2.73.79-4.25 2.17a19.43 19.43 0 0 1-6.66 3.42z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M256.79 177.8c-1.85-1.45-4.59-1-6.63.23s-3.69 2.93-5.76 4.05c-5.74 3.11-13.45.83-18.9 4.45-5.12 3.41-6 10.43-6.4 16.57-1 15.6-1.86 31.31-5.61 46.49-1 4-2.2 8.1-1.82 12.22a32.43 32.43 0 0 0 1.66 6.9l4.92 15.37c2.28 7.14 4.59 14.39 4.83 21.88s-1.52 14.61-3.27 21.76a255.21 255.21 0 0 0-6.73 42.91c-.31 4.79-.44 9.79 1.5 14.18 2 4.59 6.06 8 10.34 10.59s8.93 4.59 13.12 7.34c8.41 5.53 15.16 14.24 25 16.51 4.51 1 9.23.6 13.77-.28 0 0-2.57-116.72-9.72-133.39s-13.49-88.88-13.49-91.26 3.19-16.52 3.19-16.52zM295.41 181.62s37.55 0 43.11 19.84-15.87 52.38-15.87 52.38 8.73 64.28 12.69 70.63 2.39 19 2.39 19a52.51 52.51 0 0 1 1.58 27c-3.17 14.28-15.08 39.68-15.08 39.68s-15.87 0-19.84 9.52-4.76-41.27-4.76-41.27-14.28-92.85-13.49-98.4 4.76-51.59 6.35-64.29 5.05-29.33 2.92-34.09z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M324.23 194.32s18.26 5.55 18.26 11.9 5.59 40.47 5.59 51.58-2.38 12.7 0 16.67-25.39 2.38-25.39 2.38l-5.05-45.23z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M216.3 251.46s35.72 2.38 42.07-2.39 33.33 6.35 35.71 12.7-38.1 7.14-44.44 7.14-36.51 9.53-36.51 9.53z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M142.77 621.13s-16.65 42-8 47 99.86 1.44 99.86 1.44 15.19-9.4-2.17-15.92c0 0-14.48-.72-23.88-6.51s-20.27-16.64-20.27-16.64-.72-15.92-6.51-12.3a14.86 14.86 0 0 0-6.51 10.13z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M142.77 621.13s-16.65 42-8 47 99.86 1.44 99.86 1.44 15.19-9.4-2.17-15.92c0 0-14.48-.72-23.88-6.51s-20.27-16.64-20.27-16.64-.72-15.92-6.51-12.3a14.86 14.86 0 0 0-6.51 10.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M117.08 633.97s-18.25 46-8.73 51.58 109.52 1.59 109.52 1.59 16.67-10.31-2.38-17.46c0 0-15.87-.79-26.19-7.14s-22.22-18.28-22.22-18.28-.79-17.46-7.14-13.49a16.28 16.28 0 0 0-7.14 11.11z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M210.75 341.93l-11.11 100s-4 47.62-15.87 57.93c0 0 0 15.08-4 19.84l-5.56 62.7s7.94 23 7.15 27 3.17 16.66 2.38 18.25-38.1 0-38.1 0l7.94-127.77 24.6-177.76z",
    fill: "#3c354c"
  }), React.createElement("path", {
    d: "M210.75 341.93l-11.11 100s-4 47.62-15.87 57.93c0 0 0 15.08-4 19.84l-5.56 62.7s7.94 23 7.15 27 3.17 16.66 2.38 18.25-38.1 0-38.1 0l7.94-127.77 24.6-177.76z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M190.91 338.75s-8.73 81.74-12.7 99.2a225.33 225.33 0 0 0-4.76 34.92s-.79 25.4-7.94 32.54a21.43 21.43 0 0 0-6.34 15.85s-7.15 80.15-3.18 89.68 7.94 17.46 4 23.8-47.62 6.35-47.62 1.59 0-8.73-2.38-11.11 0-17.46 0-17.46-9.52-70.63-.79-91.26 12.7-77 12.7-77-6.35-64.28-14.29-74.6 1.59-46.82 1.59-46.82z",
    fill: "#3c354c"
  }), React.createElement("path", {
    d: "M168.57 84.91c.92 2.1 3.13 3.27 5.14 4.38 11.65 6.42 21.4 15.73 31 24.93a36.43 36.43 0 0 1 1.45-24.63c1.14-2.65 2.65-5.51 1.83-8.28-.61-2-2.34-3.52-4-4.82a124.59 124.59 0 0 0-12.27-8.37c-3-1.78-9.08-6.51-12.49-6-.18 4.61-.27 8.73-2.29 13-.5 1.06-8.02 10.59-8.37 9.79z",
    fill: "#a0616a"
  }), React.createElement("circle", {
    cx: 209.16,
    cy: 62.57,
    r: 32.54,
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M210.75 139.56s5.55-27.78-10.32-37.3-34.12-20.63-34.12-20.63-5.56-.8-7.94 11.11c0 0-45.23 8.73-50 51.58s3.18 105.55 3.18 105.55-7.14 54.76-15.87 84.12c0 0-7.15 6.35 24.6-3.17s87.29 27 87.29 27 5.56-5.56 5.56-9.53 6.35-27 6.35-27 5.55-97.61 7.93-108.72-9.52-71.42-16.66-73.01z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M161.55 194.32s43.64-25.4 34.91-57.94-27.77-42.85-27.77-42.85-30.95-10.32-57.14 23l1.59 15.08s28.57-57.93 59.52-21.43-11.11 84.14-11.11 84.14z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M114.72 118.13v130.13l-8.11 44.39-3.79 20.69H75.08L36.2 299.05v-96s32.53-64.29 42.85-76.19 35.67-8.73 35.67-8.73z",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M106.6 292.66l-3.78 20.69H75.04l-38.88-14.28 70.44-6.41z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M105.2 264.94l68.25-83.33-60.32 86.51-6.35 1.58-1.58-4.76z"
  }), React.createElement("path", {
    d: "M201.49 65.93c1.85-1.25 4.17-1.48 6.39-1.7s4.54-.52 6.31-1.88c3.07-2.36 3.3-6.92 5.55-10.07 3.25-4.57 9.74-5.12 15.35-4.9 3.43.14 7.12.35 10-1.5s4.3-5.5 5.3-8.87c1.19-4 1.95-8.88-1-11.84-2-2.06-5.24-2.47-7.5-4.28s-3.31-4.92-4.58-7.63a20.66 20.66 0 0 0-6.65-8.33c-4.26-3-9.7-3.62-14.89-3.57s-10.4.74-15.55.1C196 .94 191.79-.46 187.59.16c-5.36.79-9.79 4.84-12.44 9.57s-3.77 10.13-4.87 15.43l-3 14.43c-.92 4.48-1.85 9.07-1.14 13.58 1.48 9.36 9.76 16.8 10.33 26.25a16.11 16.11 0 0 1 9.84-11.69 3.11 3.11 0 0 1 2-.25c.82.27 1.3 1.09 1.82 1.78 1.36 1.81 5.63 4.55 8 3.27 2.26-1.15.64-4.75 3.36-6.6z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M409.15 469.7s-21.43.79-24.6 25.39 0 138.88 0 138.88 24.6 18.25 54.76 15.87 78.56-11.11 78.56-11.11v-134c0-20-16.68-36.31-36.66-35.16-.47 0-1 .06-1.43.11z",
    fill: "#3c354c"
  }), React.createElement("circle", {
    cx: 440.1,
    cy: 653.81,
    r: 14.28,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 517.87,
    cy: 647.46,
    r: 14.28,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M119.49 214.16s-5.56 34.91 17.45 31.74c0 0 11.91-1.59 13.5 0s60.31-8.73 68.25-17.46c0 0 9.52-3.17 14.28 1.59s52.38 9.52 38.11-4.77-36.5-17.46-36.5-17.46l-30.16 1.58s-15.87 4.77-25.39 0-36.53-3.12-36.53-3.12z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M152.02 103.85s-35.71 4-35.71 55.55v65.86s19.84-8.73 23.81-7.94S159.96 207 159.96 207s18.25-42.84 16.66-54.74-.79-46.83-24.6-48.41zM315.5 231.61l-35.71 25.4 22.22 2.38 30.95-26.19-17.46-1.59z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M343.28 269.71s8.73 27-3.17 34.92-31.75-27.78-31.75-27.78-21.43-25.39-7.14-30.95 20.12 18.65 20.12 18.65l18.74 16.27z",
    fill: "#fbbebe"
  }), React.createElement("ellipse", {
    cx: 288.92,
    cy: 134.79,
    rx: 31.74,
    ry: 20.24,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 294.47,
    cy: 85.99,
    r: 23.01,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 209.16,
    cy: 42.34,
    rx: 30.55,
    ry: 15.87,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 180.59,
    cy: 45.11,
    rx: 10.71,
    ry: 26.59,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M21.17 672.8c3-5.51-.4-12.26-4.28-17.18s-8.62-10-8.52-16.29c.15-9 9.7-14.31 17.33-19.08a84.45 84.45 0 0 0 15.56-12.51 22.56 22.56 0 0 0 4.78-6.4c1.58-3.52 1.54-7.52 1.44-11.38q-.5-19.26-1.91-38.48",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), React.createElement("path", {
    d: "M60.08 550.77a14 14 0 0 0-7-11.5l-3.14 6.22.1-7.52a14 14 0 1 0 10.04 12.8zM35.08 645.77a14 14 0 1 1 .68-11.3l-8.77 7.13 9.65-2.24a13.89 13.89 0 0 1-1.56 6.41zM28.08 618.52a14 14 0 0 1-14.67-13.37 13.82 13.82 0 0 1 1.21-6.39 14.06 14.06 0 0 1 9-7.78l-.07 5.79 3.17-6.29a14 14 0 0 1 14.67 13.37 13.84 13.84 0 0 1-.6 4.79 14 14 0 0 1-12.71 9.88zM62.19 595.85a14 14 0 1 1 6.21-26.27l-2.48 6.8 5.1-4.9a14 14 0 0 1-8.83 24.37z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M58.19 554.51c-3.23.36-6.39 1.37-9.64 1.57s-6.82-.58-8.87-3.11c-1.11-1.36-1.67-3.08-2.6-4.56a10.05 10.05 0 0 0-3.53-3.33 14 14 0 1 0 26.23 9.32c-.53.02-1.06.06-1.59.11zM62.19 595.85a14.06 14.06 0 0 1-13.35-20 10.3 10.3 0 0 1 2.83 2.83c1 1.51 1.6 3.25 2.78 4.64 2.18 2.57 5.92 3.41 9.3 3.25s6.66-1.11 10-1.42c.47 0 .95-.08 1.42-.09a14 14 0 0 1-12.98 10.79zM28.08 618.52a14 14 0 0 1-14.67-13.37 13.82 13.82 0 0 1 1.21-6.39 11.32 11.32 0 0 1 3 2.85c1.09 1.54 1.77 3.31 3 4.73 2.37 2.64 6.35 3.57 9.94 3.48s6.82-.93 10.27-1.19a14 14 0 0 1-12.75 9.89zM35.08 645.77A14.013 14.013 0 0 1 9.5 634.32a14.25 14.25 0 0 1 3.08 2.74c1.33 1.63 2.21 3.47 3.75 5 2.87 2.82 7.5 4 11.63 4.09a62.17 62.17 0 0 0 7.12-.38z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M0 666.46s11.08-.34 14.42-2.72 17-5.22 17.87-1.4 16.64 19 4.14 19.06-29.06-1.95-32.39-4S0 666.46 0 666.46z",
    fill: "#656380"
  }), React.createElement("path", {
    d: "M36.65 680.07c-12.51.1-29.06-1.95-32.39-4-2.54-1.54-3.55-7.09-3.89-9.65H0s.7 8.93 4 11 19.88 4.08 32.39 4c3.61 0 4.85-1.31 4.79-3.22-.47 1.13-1.84 1.85-4.53 1.87z",
    opacity: 0.2
  }));
};
UndrawTravelers.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawTravelers;